<template>
    <div>
        <a-tabs v-model="time_type" @change="callback">
            <a-tab-pane key="perMinute" tab="某分统计">
            </a-tab-pane>
            <a-tab-pane key="perHour" tab="某时统计">
            </a-tab-pane>
            <a-tab-pane key="perDay" tab="某日统计">
            </a-tab-pane>
        </a-tabs>

        <div class="searchBox">
            <label for="" style="">选择日期：</label>

            <a-date-picker class="searchItem" :disabled-date="disabledDate" @change="onChange" v-model="current_time" />

            <a-time-picker class="searchItem" v-model="current_time" v-if="time_type != 'perDay'"
                :format="current_format" />


            <span v-if="onlyFlow == 1">
                <label for="">服务提供方：</label>
                <a-select class="formInput" v-model="selectedAppcode" @change="handleSupplierChange" show-search allow-clear>
                    <a-select-option v-for="(item,index) in appcodes" :key="index" :value="item">
                        {{item}}
                    </a-select-option>
                </a-select>

                <label for="">服务消费方：</label>
                <a-select class="formInput" v-model="selectedInvokeappcode" show-search allow-clear>
                    <a-select-option v-for="(item,index) in invokappcodes" :key="index" :value="item">
                        {{item}}
                    </a-select-option>
                </a-select>
            </span>
            <span v-if="onlyFlow == 1">
                <label for="">调用方式：</label>
                <a-select  class="formInput" v-model="selectedType" show-search>
                    <a-select-option value="">
                        全部
                    </a-select-option>
                    <a-select-option value="rpc">
                        rpc
                    </a-select-option>
                    <a-select-option value="mq">
                        mq
                    </a-select-option>
                    <a-select-option value="http">
                        http
                    </a-select-option>
                </a-select>
                

                <span v-if="selectedType == 'mq'">
                    <label for="">serverName关键字：</label>
                    <a-input  class="formInput" v-model="severNameKeyWord" placeholder="请输入关键字" />
                </span>
                
                <span v-if="selectedType == 'mq'">
                    <label for="">topic关键字：</label>
                    <a-input class="formInput"  v-model="topicKeyWord" placeholder="请输入关键字" />
                </span>

                <br>
                <label for="">服务或方法：</label>
                <serviceSelecter :searchTimeRange="getTimeRange()" :selectedAppcode="selectedAppcode"
                :selectedInvokeappcode="selectedInvokeappcode" ref="myServiceSelecter"
                @onAppCodeChange="handleServiceKeyChange" style="width:700px;margin-right:20px;"></serviceSelecter>
                
            </span>

            <a-button class="searchItem" type="primary" @click="handleSubmit">查询</a-button>

            <a-button class="searchItem" type="primary" @click="handleReset">重置</a-button>
        </div>

    </div>
</template>
<script>

import moment from 'moment';
import serviceSelecter from '../servicesum/serviceselecter'
const oneDayLong = 24 * 60 * 60 * 1000;
const oneMinitLong = 60 * 1000;
export default {
    data() {
        return {
            time_type:'',
            current_format:'',
            current_time: null,
            selectedAppcode:'',
            selectedType:'',
            severNameKeyWord:'',
            servicekey:'',
            topicKeyWord:'',
            selectedInvokeappcode:'',
            appcodes:[],
            invokappcodes:[],
        };
    },
    methods: {
        setDefaultUrl(url_){
            this.$refs.myServiceSelecter.setDefaultValue(url_);
            this.handleSubmit();
        },
        handleServiceKeyChange(value){
            this.servicekey = value;
            let t_range = this.getTimeRange()
            this.G.getServiceConsumApps(this.selectedAppcode,t_range.split('~')[0],t_range.split('~')[1],this,this.servicekey)
        },

        disabledDate(current) {
            // 日志库保存日期默认14天，可选择19天以内时间
            return current && current < moment().subtract(14, 'days');
        },
        getCachData(){
            let chachedData = localStorage.getItem('monitorserviceSearch');
            if(chachedData){
                chachedData = JSON.parse(chachedData);
                this.selectedAppcode = chachedData.selectedAppcode;
                this.selectedType = chachedData.selectedType;
                this.severNameKeyWord = chachedData.severNameKeyWord;
                this.topicKeyWord = chachedData.topicKeyWord;
                this.selectedInvokeappcode = chachedData.selectedInvokeappcode;
                this.time_type = chachedData.time_type;
                this.current_format = chachedData.current_format;
                this.current_time = moment(chachedData.current_time) ;
            }
            else{
                if(this.appcodes){
                    this.selectedAppcode = this.appcodes.length > 0 ? this.appcodes[0] : '';
                }
                this.selectedType = "";
                this.severNameKeyWord = "";
                this.topicKeyWord = "";
                this.selectedInvokeappcode = "";
                this.time_type = 'perMinute';
                this.current_format = 'HH:mm';
                this.current_time = moment(new Date(new Date().getTime() - oneMinitLong));
            }

            

            let query = this.$route.query;
            if(query.appcode){
                this.selectedAppcode = query.appcode;
            }

            if(this.$route.path == '/mqinfo/mqsum'){
            //mq统计，默认选择mq
                this.selectedType = 'mq'
            }
            this.handleSupplierChange();
        },
        updateCache(){
            const {selectedAppcode,topicKeyWord,severNameKeyWord,selectedType,selectedInvokeappcode,time_type,current_format,current_time} = this;
            let result = {
                selectedAppcode,
                selectedType,
                topicKeyWord,
                severNameKeyWord,
                selectedInvokeappcode,
                time_type,
                current_format,
                current_time:new Date(current_time).Format('yyyy-MM-dd hh:mm:ss'),
            }
            localStorage.setItem('monitorserviceSearch',JSON.stringify(result))
        },
        onChange(date, dateString) {
            console.log(date, dateString);
        },
        callback(v){
            this.time_type = v;
            if(v == 'perDay'){
                this.current_format = 'HH'
            }
            else if(v == 'perHour'){
                this.current_format = 'HH'
            }
            else if(v == 'perMinute'){
                this.current_format = 'HH:mm'
            }
            let t_range = this.getTimeRange()
            this.G.getServiceConsumApps(this.selectedAppcode,t_range.split('~')[0],t_range.split('~')[1],this,this.serviceke)
        },
        handleReset(){
            localStorage.setItem('monitorserviceSearch','');
            this.$refs.myServiceSelecter.setDefaultValue('');
            this.getCachData();
            this.handleSubmit();
        },
        getTimeRange(){
            let c_date = new Date(this.current_time).Format("yyyy-MM-dd");
            let c_time = new Date(this.current_time).Format("hh:mm");
            let result_s = "";
            let result_e = "";
            switch (this.time_type) {
                case "perDay":
                    result_s = c_date + " 00:00:00";
                    result_e =  new Date((new Date(result_s)).getTime() + oneDayLong).Format('yyyy-MM-dd hh:mm:ss');
                    break;
                case "perHour":
                    result_s = c_date + " " + c_time.split(':')[0] + ":00:00";
                    result_e =  new Date((new Date(result_s)).getTime() + oneMinitLong * 60).Format('yyyy-MM-dd hh:mm:ss');
                    break;
                case "perMinute":
                    result_s = c_date + " " + c_time + ":00";
                    result_e =  new Date((new Date(result_s)).getTime() + oneMinitLong).Format('yyyy-MM-dd hh:mm:ss');
                    break;
                default:
                    break;
            }
            return result_s + '~' + result_e
        },
        handleSubmit(){
            if(this.appcodes.length == 0){
                this.message.info("抱歉，您没有任何app的授权，请联系架构部授权系统");
                return
            }
            let c_date = new Date(this.current_time).Format("yyyy-MM-dd");
            let c_time = new Date(this.current_time).Format("hh:mm");
            let result_s = "";
            let result_e = "";
            
            let resultTimetype = 9;
            switch (this.time_type) {
                case "perDay":
                    result_s = c_date + " 00:00:00";
                    result_e =  new Date((new Date(result_s)).getTime() + oneDayLong).Format('yyyy-MM-dd hh:mm:ss');
                    resultTimetype = 11;
                    break;
                case "perHour":
                    result_s = c_date + " " + c_time.split(':')[0] + ":00:00";
                    result_e =  new Date((new Date(result_s)).getTime() + oneMinitLong * 60).Format('yyyy-MM-dd hh:mm:ss');
                    resultTimetype = 9;
                    break;
                case "perMinute":
                    result_s = c_date + " " + c_time + ":00";
                    result_e =  new Date((new Date(result_s)).getTime() + oneMinitLong).Format('yyyy-MM-dd hh:mm:ss');
                    resultTimetype = 7;
                    break;
                default:
                    break;
            }
            let result = {
                selectedAppcode:this.selectedAppcode,
                selectedType:this.selectedType,
                severNameKeyWord:this.severNameKeyWord,
                topicKeyWord:this.topicKeyWord,
                selectedInvokeappcode:this.selectedInvokeappcode,
                searchTimeRange:result_s + '~' + result_e,
                timeType:resultTimetype,
                servicekey:this.servicekey 
            }
            this.updateCache();
            this.$emit("searchChange",result);
        },
        handleSupplierChange(){
            let t_range = this.getTimeRange()
            this.G.getServiceConsumApps(this.selectedAppcode,t_range.split('~')[0],t_range.split('~')[1],this,this.serviceke)
        }
        
    },
    props:{
        onlyFlow:Number
    },
    components:{
        serviceSelecter
    },
    mounted(){
        this.appcodes = this.G.getAllAppcodes(this);
        this.invokappcodes = this.appcodes;
        //缓存搜索条件
        this.getCachData();
        this.handleSubmit();
    }
};
</script>
<style scoped>
    .searchBox{
        width: 100%;
        padding-bottom: 20px;
        line-height: 50px;
    }
    .searchItem{
        margin-right: 20px;
    }

    .formInput{
        width:112px;
        margin-right:10px;
    }
</style>
